// Helper function to calculate actual P&L based on position size
export const calculateActualPnL = (trade) => {
  try {
    if (!trade || trade.status !== 'closed') {
      return trade?.pnlAbs || 0;
    }
    
    // If we have stored pnlAbs and it's valid, use it
    if (trade.pnlAbs !== undefined && trade.pnlAbs !== null && !isNaN(trade.pnlAbs)) {
      return Number(trade.pnlAbs);
    }
    
    // Try to calculate from price difference
    const entryPrice = trade.entryPrice;
    const exitPrice = trade.exitPrice;
    const positionSize = trade.positionSize;
    
    if (!entryPrice || !exitPrice || entryPrice === 0 || exitPrice === 0) {
      return 0; // Can't calculate without valid prices
    }
    
    if (!positionSize || positionSize === 0) {
      console.warn('Missing or invalid position size for trade:', trade.tradeId);
      return 0;
    }
    
    // Calculate actual P&L based on position size and price difference
    let calculatedPnL = 0;
    if (trade.direction === 'long') {
      calculatedPnL = (Number(exitPrice) - Number(entryPrice)) * Number(positionSize);
    } else if (trade.direction === 'short') {
      calculatedPnL = (Number(entryPrice) - Number(exitPrice)) * Number(positionSize);
    } else {
      console.warn('Unknown trade direction:', trade.direction, 'for trade:', trade.tradeId);
      return 0;
    }
    
    return Number(calculatedPnL);
  } catch (error) {
    console.error('Error calculating P&L for trade:', trade?.tradeId, error);
    return 0;
  }
};
